import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  Typography,
  Divider,
  useTheme,
  Grid,
} from "@mui/material";
import { searchPermissions } from "../../Users/PermissionsUser/PermissionsActions";

export default function ReportsInspections(props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [reportDamageInspection, setReportDamageInspection] = useState(false);
  const [reportDamageArea, setReportDamageArea] = useState(false);
  const language = localStorage.getItem("language");

  useEffect(() => {
    const permissionsArray = JSON.parse(localStorage.getItem("permissions"));

    const permissionReportDamageInspection = searchPermissions(
      "ReportesInspeccion",
      "ReporteInspeccionesDañosInspector",
      permissionsArray
    );

    const permissionDamageArea = searchPermissions(
      "ReportesInspeccion",
      "ReporteInspeccionesDañosArea",
      permissionsArray
    );

    setReportDamageInspection(permissionReportDamageInspection);
    setReportDamageArea(permissionDamageArea);
  });

  return (
    <Card
      variant="outlined"
      sx={{
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
      }}
    >
      <CardContent>
        <CardContent
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "space-between",
            overflow: "hidden",
            maxWidth: "100%",
          }}
        >
          <Typography variant="h3" sx={{ flex: "1", fontWeight: "bold" }}>
          {t("ReportsInspections.title")}
          </Typography>
        </CardContent>
        <Divider sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }} />
        <CardContent>
          <Grid container spacing={2}>
            {reportDamageInspection && (
              <Grid item xs={12} sm={6}>
                <Link
                  to="/ReportesInspeccion/ReporteDeDañosPorInspector"
                  style={{ textDecoration: "none" }}
                >
                  <Card
                    variant="outlined"
                    sx={{
                      overflow: "hidden",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      border: "1px solid rgba(0, 0, 0, 0.1)",
                      borderRadius: 2,
                      transition: "background-color 0.3s ease",
                      "&:hover": { backgroundColor: theme.palette.grey[200] },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="h6"
                        style={{ color: theme.palette.primary.main }}
                      >
                        {t("ReportsInspections.reportInspectorTitle")}
                        <Divider
                          sx={{
                            maxWidth: "100%",
                            margin: "auto",
                            marginTop: 2,
                          }}
                        />
                      </Typography>
                      <Typography variant="body1" sx={{ marginTop: 2 }}>
                         {t("ReportsInspections.reportInspectorDescription")}
                      </Typography>
                    </CardContent>
                  </Card>
                </Link>
              </Grid>
            )}
            {reportDamageArea && (
              <Grid item xs={12} sm={6}>
                <Link
                  to="/ReportesInspeccion/ReporteDeDañosPorArea"
                  style={{ textDecoration: "none" }}
                >
                  <Card
                    variant="outlined"
                    sx={{
                      overflow: "hidden",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      border: "1px solid rgba(0, 0, 0, 0.1)",
                      borderRadius: 2,
                      transition: "background-color 0.3s ease",
                      "&:hover": { backgroundColor: theme.palette.grey[200] },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="h6"
                        style={{ color: theme.palette.primary.main }}
                      >
                        {t("ReportsInspections.reportAreaTitle")}
                      </Typography>
                      <Divider
                        sx={{
                          maxWidth: "100%",
                          margin: "auto",
                          marginTop: 2,
                        }}
                      />
                      <Typography variant="body1" sx={{ marginTop: 2 }}>
                        {t("ReportsInspections.reportAreaDescription")}
                      </Typography>
                    </CardContent>
                  </Card>
                </Link>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </CardContent>
    </Card>
  );
}
